/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateGithubVerificationKeyInput = {
    currentUrl?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createGithubVerificationKeyMutationVariables = {
    input: CreateGithubVerificationKeyInput;
};
export type createGithubVerificationKeyMutationResponse = {
    readonly createGithubVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type createGithubVerificationKeyMutation = {
    readonly response: createGithubVerificationKeyMutationResponse;
    readonly variables: createGithubVerificationKeyMutationVariables;
};



/*
mutation createGithubVerificationKeyMutation(
  $input: CreateGithubVerificationKeyInput!
) {
  createGithubVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateGithubVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGithubVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createGithubVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createGithubVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createGithubVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createGithubVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createGithubVerificationKeyMutation(\n  $input: CreateGithubVerificationKeyInput!\n) {\n  createGithubVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c4f34a5ba08be8064e613c34a01d4c09';
export default node;
